<template>
  <icon class="verified-icon" name="verified" />
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },
};
</script>

<style lang="scss" scoped>
.verified-icon {
  cursor: pointer;
  color: $color-green-1;
}
</style>
